<mat-chip-listbox
  multiple
  aria-label="Filter Chips selection"
  role="list"
>
  @for (filterChip of filterChips(); track filterChip.id) {
    <mat-chip-option
      color="accent"
      role="listitem"
      [selected]="selected().includes(filterChip)"
      (selectionChange)="selectionChanged($event, filterChip)">
      {{ filterChip.title }}
      @if (!!filterChip.count || filterChip.count === 0) {
        <span>({{ filterChip.count }})</span>
      }
    </mat-chip-option>
  }
</mat-chip-listbox>
